<template>
  <div
    class="flex flex-row items-center gap-2 text-sm cursor-pointer select-none text-gray-800 group/child"
    :title="item.title"
    @click="onClick(item)"
  >
    <SidebarChildIcon
      v-tooltip.right="{
        content: item.title,
        disabled: !compactMode
      }"
      :tooltip="item.title"
      :icon="item.icon"
      :compact="compactMode"
    />
    <span
      v-if="!compactMode"
      class="py-2 group-hover/child:text-primary truncate font-medium"
    >
      {{ item.title }}
    </span>
    <BookmarkControl
      v-if="!compactMode"
      class="ml-auto self-stretch"
      v-bind="{ item }"
    />
  </div>
</template>

<script setup lang="ts">
import { MenuItem } from "@q-food/q-food";
import { useAppSidebarStore } from "~/stores/AppSidebar";

defineProps<{
  item: MenuItem;
}>();
const { compactMode } = storeToRefs(useAppSidebarStore());

const { push } = useRouter();

function onClick(item: MenuItem) {
  if (Object.values(item.props).length > 0) {
    const query = new URLSearchParams(item.props).toString();
    push("/" + item.action.replace(".", "/") + `?${query}`);
  } else {
    push("/" + item.action.replace(".", "/"));
  }
}
</script>

<style scoped></style>
